import request from '@/config/axios'

/** 获取景区总裁驾驶舱数据 */
export const getCockpitData = (params?: any) => request.get({ url: '/scenic/cockpit/data', params })

/** 获取问卷总裁驾驶舱数据 */
export const getSurveyCockpitData = (params?: any) => request.get({ url: '/survey/cockpit/data', params })

/** 获取微场景总裁驾驶舱数据 */
export const getMicrosceneCockpitData = (params?: any) => request.get({ url: '/microscene/cockpit/data', params })

/** 获取投融资总裁驾驶舱数据 */
export const getFinCockpitData = (params?: any) => request.get({ url: '/fin/cockpit/data', params })
